import HubFilter from "components/shared-components/RemoteTable/HubFilter/HubFilter";
import { useHubList } from "hooks/hub-management/useHub";
import { useTimeSlotListType } from "hooks/time-slot/useTimeSlot";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
} from "reactstrap";
import { Switch } from "antd";

const FilterGroup = ({ timeSlotParams, setTimeSlotParams }) => {
  const { t } = useTranslation(["timeslot"]);
  const [isTypeFilter, setIsTypeFilter] = useState(false);
  const [selectedTypeFilter, setSelectedTypeFilter] = useState(null);

  const handleTypeFilter = type => {
    setSelectedTypeFilter(type.value);
    setTimeSlotParams(prev => ({
      ...prev,
      "filter[type]": type.value,
    }));
  };

  const {
    refetch: fetchTimeSlotListType,
    isFetching: isLoadingTimeSlotListType,
    data: dataTimeSlotListType,
  } = useTimeSlotListType();

  const typeOptions = dataTimeSlotListType;

  const { data: listHub, refetch: fetchHub } = useHubList({
    params: {
      page: 1,
      sizePerPage: 100,
      columnFilter: {
        "filter[record_status]": "O",
      },
    },
  });

  // const [is_level_2, setIsLevel2] = useState(true);
  // const handleChangeIsLevel2 = value => {
  //   setIsLevel2(value);
  //   setTimeSlotParams(prev => ({
  //     ...prev,
  //     columnFilter: {
  //       ...prev.columnFilter,
  //       "filter[hub_id]": null,
  //     },
  //     page: 1,
  //     run: true,
  //   }));
  // };

  useEffect(() => {
    fetchHub();
    fetchTimeSlotListType();
  }, []);

  const optionsHub = useMemo(() => {
    return listHub?.items?.map(item => ({
      label: item.name,
      value: item.id,
    }));
  }, [listHub]);

  const handleHubFilter = item => {
    setTimeSlotParams(prev => ({
      ...prev,
      "filter[hub_id]": item ? item.value : undefined,
    }));
  };

  return (
    <>
      {/* <div>
        <Select
          placeholder={t("placeholder.select", {
            title: t("form.hub"),
          })}
          onChange={handleHubFilter}
          options={optionsHub || []}
          isSearchable
          className="basic-single z-index-3 w-250px"
          classNamePrefix="select"
          isClearable
        />
      </div> */}
      {/* <div className="d-flex align-items-center gap-1 ">
        <Label
          style={{ cursor: "pointer" }}
          htmlFor="is_level_2"
          onClick={() => handleChangeIsLevel2(!is_level_2)}
        >
          <Switch checked={is_level_2} onChange={handleChangeIsLevel2} />
          Địa chỉ 2 cấp
        </Label>
      </div> */}
      <div>
        <HubFilter
          mainFilterParams={timeSlotParams}
          setMainFilterParams={setTimeSlotParams}
          handleChangeHub={hubId => {
            setTimeSlotParams(prev => ({
              ...prev,
              columnFilter: {
                ...prev.columnFilter,
                "filter[hub_id]": hubId,
              },
              page: 1,
              run: true,
            }));
          }}
          isNotFilterChildHub={true}
          isHaveAllOption={true}
          isFilterAllDefault={true}
          addressLevel={3}
        />
      </div>
      <div>
        <Dropdown
          isOpen={isTypeFilter}
          toggle={() => setIsTypeFilter(!isTypeFilter)}
        >
          <DropdownToggle className="btn primary-btn w-100" caret>
            {t("form.type")}
            {selectedTypeFilter !== null && (
              <span>
                :&nbsp;
                {
                  dataTimeSlotListType?.find(
                    t => t?.value == selectedTypeFilter
                  )?.label
                }
              </span>
            )}
            <i className="mdi mdi-chevron-down" />
          </DropdownToggle>
          <DropdownMenu className="w-100">
            {typeOptions?.length > 0 &&
              typeOptions.map((type, index) => (
                <DropdownItem
                  key={`type-${index}`}
                  onClick={() => handleTypeFilter(type)}
                >
                  {type.label}
                </DropdownItem>
              ))}
          </DropdownMenu>
        </Dropdown>
      </div>
    </>
  );
};

export default FilterGroup;
